import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(() => ({
  iconStyle: {
    marginRight: "8px"
  }
}));
